export enum TabPermissionOperation {
    ADD = "add",
    DELETE = "delete"
}